// sessionStorage helper for the billing "take a demo" flow. Once a user has
// completed (or explicitly skipped) the guided demo, "Get Started" should go
// straight to the real BillingAgree flow instead of asking again.
//
// Uses sessionStorage (not localStorage) deliberately: localStorage persists
// per-browser regardless of who's logged in, so a flag set by one account
// would incorrectly carry over if a different account logs in on the same
// browser. sessionStorage is scoped to the current tab/session, so it
// naturally resets on a fresh login.

const BILLING_DEMO_STORAGE_KEY = "ogiso_billing_demo_seen";

export const hasSeenBillingDemo = () => {
  try {
    return sessionStorage.getItem(BILLING_DEMO_STORAGE_KEY) === "true";
  } catch (e) {
    return false;
  }
};

export const markBillingDemoSeen = () => {
  try {
    sessionStorage.setItem(BILLING_DEMO_STORAGE_KEY, "true");
  } catch (e) {
    // ignore
  }
};

export const resetBillingDemoSeen = () => {
  try {
    sessionStorage.removeItem(BILLING_DEMO_STORAGE_KEY);
  } catch (e) {
    // ignore
  }
};
